
import { useState } from 'react';
import Logo from "../../assets/images/login-logo.svg";
// import Loginbg from "../../assets/images/login-bg.webp";
import Loginbg from "../../assets/images/login-admin.png";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import WebService from '../../Services/WebService';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (!validateForm()) return;
        setLoading(true);

        try {
            const res: any = await WebService.postAPI({
                action: "admin-auth/forgot-password/send-otp",
                body: { email },
                isShowError: false,
            });

            toast.success(res?.message || "OTP Sent Successfully!");
            const referenceNumber = res?.reference_number;
            // navigate to next page
            navigate("/verify-otp", {
                state: { email, referenceNumber }
            });

        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit1 = (e: any) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        WebService.postAPI({
            action: "admin-auth/forgot-password/send-otp",
            body: { email },
            isShowError: false,
        }).then((res: any) => {
            if (res?.status) {
                toast.success(res?.message || "OTP Sent Successfully!");
                const referenceNumber = res?.reference_number;
                navigate("/verify-otp", {
                    state: { email, referenceNumber }
                });
            }

            setLoading(false);
        }).catch((error: any) => {
            console.error("SEND OTP ERROR:", error);
            toast.error(error?.response?.data?.message || "Failed to send OTP");
            setLoading(false);
        });
    }

    const validateForm = () => {
        let err: any = {};

        if (!email) err.email = "Please enter email";
        else if (!/\S+@\S+\.\S+/.test(email)) err.email = "Invalid email address";

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    return (
        <div className="min-h-screen flex login-page">
            {/* Left side - Image */}
            <div className="w-3/4 hidden md:block">
                <img
                    src={Loginbg}
                    alt="Login side"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Right side - Form */}
            <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-8 bg-white">
                {/* Logo */}
                <div className="mb-6 flex flex-col items-center">
                    <div className='pb-8'>
                        <img src={Logo} alt="Logo" className="" width={277} height={240} />
                    </div>
                    <h1>Forgot Password</h1>
                    <p className="text-gray-500">
                        Enter your Registered email address to recover your password
                    </p>
                </div>

                {/* Form */}
                <form className="w-full max-w-sm" onSubmit={handleSubmit1}>
                    
                    {/* Email Field */}
                    <div className="mb-4">
                        <label className="block mb-2">Email Address</label>
                        <input
                            type="email"
                            placeholder="Enter Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 ${errors.email ? "border-red-500 ring-red-300" : "border-gray-300 ring-blue-300"
                                }`}
                        />
                        {errors.email && (
                            <p className="text-red-500 text-sm mt-1 error-text">{errors.email}</p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="mt-2 w-full bg-blue-400 hover:bg-blue-500 text-white font-medium py-2 rounded-lg"
                    // onClick={handleLogin}
                    style={{ color:'#FFF' }}
                    >
                        {loading ? "Sending OTP..." : "Send OTP"}
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate("/login")}
                        className="mt-3 w-full text-sm text-blue-500 hover:text-blue-600 underline cursor-pointer bg-transparent font-medium py-2 rounded-lg"
                        style={{ color:'#FFF', textDecoration:'none' }}
                    >
                        Back to Login
                    </button>

                </form>

            </div>
        </div>
    )

}
export default ForgotPassword;